<template>
    <div class="lab-doc" v-if="expContentType==1">
        <div class="lab-doc-steps">
            <div class="step-content">
                <div class="content-title">
                    <i class="el-icon-arrow-left" @click="preStep"></i>
                    <div>{{ stepTitle[step-1] }}</div>
                    <i class="el-icon-arrow-right" @click="nextStep"></i>
                </div>
                <div class="markdown-body" v-html="stepHtml[step-1]"></div>
            </div>
            <div class="lab-tools">
                <a class="tools-catalog-btn">
                    <i class="el-icon-menu"></i>
                </a>
                <!-- <ul class="soft-list">
                    <li v-for="soft in softInfos" :key="soft.id" @click="clickSoft(soft)">
                        <img :src="soft.icon | filterUrl" />
                    </li>
                </ul> -->
                <el-button @click="nextStep()" :disabled="disable">下一步</el-button>
            </div>
        </div>
    </div>
    <div class="lab-editor" v-else-if="expContentType==2">
        <div class="lab-editor-son" style="clear:both" v-html="expRecordInfo.expContent"></div>
    </div>
    <div class="lab-pdf" v-else-if="expContentType==3">
        <embed type="application/pdf" :src="pdfUrl | filterUrl" />
    </div>
</template>

<script>
import '@/assets/css/github-markdown.min.less'
import '@/assets/css/katex.min.less'
import { getLocalLink } from '@/api/exp/expsoftware'
import { getFileInfoByUid } from '@/api/file'


export default {
    data () {
        return {
            expName: '',
            step: 1,
            stepTitle: [],
            stepHtml: [],
            softInfos: [],
            disable:false,
            pdfUrl:''
        }
    },
    props: {
        uid: {
            type: String
        },
        expRecordInfo: {
            type: Object,
            default: () => { }
        },
        expContentType:{
            type: Number,
            default:0
        }
    },
    watch: {
        expRecordInfo: {
            handler () {
                this.init()
            },
            deep: true,
            immediate: true
        },
        'step'(val){
            if(val == this.stepHtml.length)
            this.disable = true
            else
            this.disable = false
        }
    },
    methods: {
        init () {
            const { expName, expContent } = this.expRecordInfo
            if (expName && expContent) {
                this.expName = expName
                const mdHtml = expContent.split('<p></p>')
                if (mdHtml.length > 2) {
                    // 切割数据
                    const stepHtml = mdHtml[2].split(/<h2>|<h3>/)
                    let index = 1
                    stepHtml.map(row => {
                        if (row) {
                            // 先截取出步骤内容项
                            const step = row.split(/<\/h2>|<\/h3>/)
                            if (step[1]) {
                                // 判断仿真软件是否存在
                                let stepHtml = step[1]
                                if (stepHtml.indexOf('<soft>') > -1) {
                                    const outHtml = stepHtml.split(/<soft>|<\/soft>/)
                                    let softInfo
                                    outHtml.map(row => {
                                        if (row.indexOf('data-code') > -1) {
                                            softInfo = row
                                            stepHtml = stepHtml.replace(softInfo, '')
                                            if (softInfo) {
                                                let softJson = null
                                                if (softInfo.indexOf('data-code="') > -1)
                                                    softJson = JSON.parse(softInfo.split(/data-code="|">/)[1].replace(/&quot;/g, '"'))
                                                if (softInfo.indexOf("data-code='") > -1)
                                                    softJson = JSON.parse(softInfo.split(/data-code='|'>/)[1].replace(/&#10;/g, ''))
                                                if (softJson) {
                                                    Object.assign(softJson, { step: index })
                                                    this.softInfos.push(softJson)
                                                }
                                            }
                                        }
                                    })
                                }
                                this.stepHtml.push(stepHtml)

                                // 再处理标题
                                const title = step[0].split(/<\/a>/)
                                this.stepTitle.push(title[1])
                                index++
                            }
                        }
                    })
                }
            }
            if(this.expContentType==3) {
                getFileInfoByUid(expContent).then(res=>{
                   this.pdfUrl = res.originalPath
                })
            }
        },
        // 上一步
        preStep () {
            if (this.step > 1)
                this.step--
        },
        // 下一步
        nextStep () {
            if (this.step < this.stepHtml.length) this.step++
        },
        // 点击仿真软件
        clickSoft (soft) {
            const row = { ...soft }
            Object.assign(row, { taskUid: this.uid })
            row.appprama = JSON.stringify(row.appprama)
            getLocalLink(row).then(res => {
                window.location.href = res.url
            })
        }
    }
}
</script>

<style lang="less" scoped>
.lab-doc {
    height: 100%;
    position: relative;
    height: calc(100% - 53px);
    .lab-doc-steps {
        height: 100%;
        .step-content {
            height: 100%;
            overflow-y: auto;
            .content-title {
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 30px;
                background: #fff;
                font-size: 22px;
                font-weight: 700;
                text-align: center;
            }
            .markdown-body {
                max-width: 1280px;
                margin: auto;
                padding: 20px;
                height: calc(100% - 100px);
                overflow-y: auto;
            }
        }
        .lab-tools {
            // position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 10px 5px 20px;
            background: #fff;
            border-top: 1px solid #eee;
            .tools-catalog-btn {
                color: #999;
                font-size: 24px;
                cursor: pointer;
            }
            .soft-list {
                overflow: hidden;
                li {
                    float: left;
                    cursor: pointer;
                    padding: 0 10px;
                    img {
                        width: 34px;
                        height: 34px;
                    }
                }
            }
        }
    }
}
.lab-pdf{
    width: 100%;
    height: 100%;
    embed{
        width: 100%;
        height: 100%;
    }
}
.lab-editor{
    height: 100%;
    overflow:auto
}
</style>